import { render } from "./_base.vue?vue&type=template&id=39178334"
import script from "./_base.vue?vue&type=script&lang=ts&setup=true"
export * from "./_base.vue?vue&type=script&lang=ts&setup=true"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "39178334"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39178334', script)) {
    api.reload('39178334', script)
  }
  
  module.hot.accept("./_base.vue?vue&type=template&id=39178334", () => {
    api.rerender('39178334', render)
  })

}

script.__file = "resources/ts/components/form/_base.vue"

export default script